import { REACT_FRONTEND_ENABLED } from 'src/config/releaseFeatures'
import { registerExternalEditorRoute } from 'src/CrudManager/Core/composables/CrudUtils/externalEditorRoutes'
import { useUserStore } from 'src/CrudManager/Core/stores/useUserStore'
import type { Router, RouteRecordRaw } from 'vue-router'

// The profile is the partner record's editor now: every editor-shaped
// navigation CrudManager builds for these models lands here, and the page's
// recents stamps resolve their URL through the same registration.
registerExternalEditorRoute('business_partner', (id) => `/clients/${id}`)
registerExternalEditorRoute('supplier', (id) => `/clients/${id}`)

export const clientProfileRoutes: RouteRecordRaw[] = [
  {
    path: '/clients/:id',
    name: 'client-profile',
    component: () => import('./ClientProfilePage.vue'),
    meta: {
      title: 'Fiche client',
      requiresAuth: true,
    },
    // the same grant the profile endpoint enforces, checked before the page
    // mounts — the server still 403s, this only spares the dead-end screen
    beforeEnter: () => {
      const userStore = useUserStore()
      if (!userStore.hasPermission('cm-business_partner_read')) {
        return { path: '/' }
      }
      return true
    },
  },
]

/**
 * Every slug the business-partner record answers to — the client model, the
 * supplier alias of the same model, fr and en — and both Editor slugs.
 */
const PARTNER_EDITOR = /^(\/react)?\/manage\/(business-partners|partenaires|suppliers|supplier|fournisseurs|fournisseur)\/(edit|editer)\/([^/]+)\/?$/

/**
 * The profile is the record's only front door: the tab editor is gone, and a
 * partner is one record whether it sells to us or buys from us, so supplier
 * URLs land on the same screen. Unconditional — the jobs the tabs used to
 * hold live in the profile's own panels now. A `/react` editor URL lands on
 * the React profile when the frontend release flag is enabled.
 */
export function registerClientProfileRedirect(router: Router): void {
  router.beforeEach((to) => {
    const match = to.path.match(PARTNER_EDITOR)
    if (match) {
      // the query rides along: `?component=leasing` is a tab bookmark, and the
      // profile page maps the old tab names onto its own dialogs
      return {
        path: `${REACT_FRONTEND_ENABLED ? (match[1] ?? '') : ''}/clients/${match[4]}`,
        query: to.query,
        ...(REACT_FRONTEND_ENABLED ? {} : { hash: to.hash }),
        replace: true,
      }
    }
    return true
  })
}

export default clientProfileRoutes
